import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  CardImg
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

const HeaderShopName = props => {

  const [shopname, setShotname] = useState("TekyMart")
  const [shopLogo, setShotLogo] = useState()

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setShotname(obj.storename)
      if(obj.storelogo){
        setShotLogo(obj.storelogo)
      }
    }
  }, [props.success])

  return (
    <React.Fragment>
      <div className="d-inline-block ms-2 d-flex align-items-center">
        {shopLogo && <CardImg className="img-fluid logo-mmd me-3" src={shopLogo} alt="logo" />}
        <div className="align-items-center align-self-center store-name">
          {shopname}
        </div>
      </div>
    </React.Fragment>
  )
}

HeaderShopName.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(HeaderShopName))
)
